<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>视光配镜</el-breadcrumb-item>
      <el-breadcrumb-item>配镜处方单</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 筛选条件 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <el-input v-model="keywords.orderid" @keyup.enter.native="clicksearch" placeholder="请输入订单号" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <Rsljigou :propsjigouid="keywords.jigouid" :propsjigouname="keywords.jigouname" @change="changeRsljigou"></Rsljigou>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.username" @keyup.enter.native="clicksearch" placeholder="请输入姓名" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.sex" @keyup.enter.native="clicksearch" placeholder="请输入性别" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.salechannel" @keyup.enter.native="clicksearch" placeholder="请输入销售渠道" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.consignee" @keyup.enter.native="clicksearch" placeholder="请输入收货人" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.phone" @keyup.enter.native="clicksearch" placeholder="请输入手机号码" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.consigneeaddress" @keyup.enter.native="clicksearch" placeholder="请输入收货地址" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="keywords.orderstatus" placeholder="请选择" class="select"  style="width: 200px;">
              <el-option label="请选择订单状态" value="-1"></el-option>
              <el-option label="待支付" value="0"></el-option>
              <el-option label="待发货" value="1"></el-option>
              <el-option label="待收货" value="2"></el-option>
              <el-option label="已完成" value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="keywords.isyufukuan" placeholder="请选择" class="select"  style="width: 200px;">
              <el-option label="请选择是否预付款支付" value="-1"></el-option>
              <el-option label="不是" value="0"></el-option>
              <el-option label="是" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
            <el-button type="success" @click="clickexcel" v-if="SubRule_ExcelOptometristPrescriptionsList">导出</el-button>
          </el-form-item>
        </el-form>
        <!-- 筛选条件 end -->

        <!-- 数据列表 start -->
        <el-table :data="dataList" border stripe>
          <el-table-column prop="Orderid" label="订单号" min-width="10%"></el-table-column>
          <el-table-column prop="Jigouname" label="机构名称" min-width="6%"></el-table-column>
          <el-table-column prop="Username" label="姓名" min-width="6%"></el-table-column>
          <el-table-column prop="Sex" label="性别" min-width="5%"></el-table-column>
          <el-table-column prop="Age" label="年龄" min-width="5%"></el-table-column>
          <el-table-column prop="Glassestime" label="配镜时间" min-width="6%"></el-table-column>
          <el-table-column prop="Consignee" label="收货人" min-width="6%"></el-table-column>
          <el-table-column prop="Phone" label="手机号码" min-width="6%"></el-table-column>
          <el-table-column prop="Consigneeaddress" label="收货地址" min-width="6%"></el-table-column>
          <el-table-column prop="Optometrytime" label="验光日期" min-width="6%"></el-table-column>
          <el-table-column prop="Remarks" label="备注" min-width="6%"></el-table-column>
          <el-table-column prop="Optometryname" label="验光师" min-width="6%"></el-table-column>
          <el-table-column prop="Amount" label="代理商金额" min-width="6%" v-if="SubRule_Optometrist_ShowPrice"></el-table-column>
          <el-table-column prop="Amountretail" label="零售金额" min-width="6%"></el-table-column>
          <el-table-column prop="OrderstatusName" label="支付状态" min-width="6%"></el-table-column>
          <el-table-column prop="Isyufukuanname" label="是否预付款支付" min-width="6%"></el-table-column>
          <el-table-column prop="TotalPrepaymentLeft" label="预付款余额" min-width="6%" v-if="SubRule_Optometrist_ShowPrice"></el-table-column>
          <el-table-column prop="Trackingname" label="物流公司" min-width="6%"></el-table-column>
          <el-table-column prop="Trackingnumber" label="物流单号" min-width="6%"></el-table-column>
          <el-table-column prop="Createtime" label="创建时间" min-width="7%"></el-table-column>
          <el-table-column prop="operation" label="操作" min-width="10%">
            <template v-slot="scope">
              <el-button v-if="scope.row.Orderstatus == 0 && SubRule_Optometrist_OnlinePay" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickpay(scope.row)">支付</el-button>
              <el-button v-if="scope.row.Orderstatus == 0 && SubRule_Optometrist_NoOnlinePay" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickNoOnlinePay(scope.row,'线下已支付')">线下已支付</el-button>
              <el-button v-if="scope.row.Orderstatus == 0 && SubRule_Optometrist_YuFuKuanZhiFu" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickNoOnlinePay(scope.row,'预付款支付')">预付款支付</el-button>
              <el-button v-if="scope.row.Orderstatus == 0 && SubRule_Optometrist_NoOnlinePay" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickNoOnlinePay(scope.row,'活动赠送')">活动赠送</el-button>
              <el-button v-if="scope.row.Orderstatus == 0 && SubRule_Optometrist_Modify" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickModify(scope.row)">修改</el-button>
              <el-button v-if="scope.row.Orderstatus == 0 && SubRule_Optometrist_Delete" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickdel(scope.row)">删除</el-button>
              <el-button v-if="scope.row.Orderstatus == 1 && SubRule_Optometrist_Send" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickSend(scope.row)">发货</el-button>
              <el-button v-if="scope.row.Orderstatus == 2 && SubRule_Optometrist_ConfirmGoods" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickConfirmGoods(scope.row)">确认收货</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickToView(scope.row)">查看</el-button>
              <el-button v-if="SubRule_Optometrist_ExportSingle" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="apiExcelOptometristPrescriptions(scope.row,23031101)">导出(代理商价)</el-button>
              <el-button v-if="SubRule_Optometrist_ExportSingleRetail" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="apiExcelOptometristPrescriptions(scope.row,23072501)">导出(零售价)</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 数据列表 end -->

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
            :current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

    <!-- 添加 start -->
    <el-tab-pane label="添加配镜处方单" name="second">
      <OptometristPrescriptionsAdd ref="SubVuesecond" v-on:triggerFunc="BackToFirst"></OptometristPrescriptionsAdd>
    </el-tab-pane>
    <!-- 添加 end -->

    <!-- 查看 start -->
    <el-tab-pane label="查看配镜处方单" name="three" disabled="disabled">
      <OptometristPrescriptionsAdd ref="SubVuethree" v-on:triggerFunc="BackToFirst"></OptometristPrescriptionsAdd>
    </el-tab-pane>
    <!-- 查看 end -->

    <!-- 修改 start -->
    <el-tab-pane label="修改配镜处方单" name="five" disabled="disabled">
      <OptometristPrescriptionsAdd ref="SubVuefive" v-on:triggerFunc="BackToFirst"></OptometristPrescriptionsAdd>
    </el-tab-pane>
    <!-- 修改 end -->

    <!-- 发货 start -->
    <el-tab-pane label="发货" name="four" disabled="disabled">
      <el-form :model="sendForm" ref="sendFormRef" label-width="170px">
        <el-form-item label="物流公司" class="addAdminForm">
          <el-input v-model="sendForm.trackingname"></el-input>
        </el-form-item>
        <el-form-item label="物流单号" class="addAdminForm">
          <el-input v-model="sendForm.trackingnumber"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clickSendSave">保存</el-button>
          <el-button type="info" @click="clickreturn">返回</el-button>
        </el-form-item>
      </el-form>
    </el-tab-pane>
    <!-- 发货 end -->

  </el-tabs>
  </div>
</template>

<script>
import Rsljigou from '@/components/Rsljigou.vue'
import OptometristPrescriptionsAdd from '@/componentsSubVue/OptometristPrescriptionsAdd.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    Rsljigou,
    OptometristPrescriptionsAdd
  },
  name: 'MyOptometristPrescriptions',
  data () {
    return {
      activeName: 'first',
      addForm: {
        name: '',
        phone: '',
        school: '',
        grade: '',
        idnumber: ''
      },
      editForm: {
        id: '0',
        name: '',
        phone: '',
        school: '',
        grade: '',
        idnumber: ''
      },
      sendForm: {
        orderid: '',
        trackingname: '',
        trackingnumber: ''
      },
      // 查询
      keywords: {
        orderid: '',
        jigouid: '-1',
        jigouname: '',
        username: '',
        sex: '',
        salechannel: '',
        consignee: '',
        phone: '',
        consigneeaddress: '',
        orderstatus: '-1',
        isyufukuan: '-1'
      },
      dataList: [],
      dataListnum: 0,
      selectedPageNo: 1,
      SubRule_Optometrist_Send: false,
      SubRule_Optometrist_ConfirmGoods: false,
      SubRule_ExcelOptometristPrescriptionsList: false,
      SubRule_Optometrist_Modify: false,
      SubRule_Optometrist_Delete: false,
      SubRule_Optometrist_NoOnlinePay: false,
      SubRule_Optometrist_YuFuKuanZhiFu: false,
      SubRule_Optometrist_ShowPrice: false,
      SubRule_Optometrist_OnlinePay: false,
      SubRule_Optometrist_ExportSingle: false,
      SubRule_Optometrist_ExportSingleRetail: false,
      SubRule_Optometrist_DaiKeXiaDan: false
    }
  },
  mounted () {
    this.apiGetOptometristPrescriptionsNum()
    this.apiGetOptometristPrescriptionsList()

    var that = this
    Vue.prototype.FunCheckSubRule('SubRule_Optometrist_Send', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_Optometrist_Send = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_Optometrist_ConfirmGoods', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_Optometrist_ConfirmGoods = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_ExcelOptometristPrescriptionsList', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ExcelOptometristPrescriptionsList = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_Optometrist_Modify', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_Optometrist_Modify = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_Optometrist_Delete', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_Optometrist_Delete = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_Optometrist_NoOnlinePay', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_Optometrist_NoOnlinePay = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_Optometrist_YuFuKuanZhiFu', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_Optometrist_YuFuKuanZhiFu = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_Optometrist_ShowPrice', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_Optometrist_ShowPrice = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_Optometrist_OnlinePay', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_Optometrist_OnlinePay = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_Optometrist_ExportSingle', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_Optometrist_ExportSingle = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_Optometrist_ExportSingleRetail', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_Optometrist_ExportSingleRetail = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_Optometrist_DaiKeXiaDan', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_Optometrist_DaiKeXiaDan = true
      }
    })
  },
  methods: {
    BackToFirst (val) {
      this.activeName = 'first'
      this.apiGetOptometristPrescriptionsNum()
      this.apiGetOptometristPrescriptionsList()
    },
    handleClick(tab, event) {
      if(tab.name == 'second'){
        this.$refs.SubVuesecond.InitData(this.SubRule_Optometrist_ShowPrice,this.SubRule_Optometrist_DaiKeXiaDan)
      }
    },
    changeRsljigou (vid, vname) {
      this.keywords.jigouid = vid
      this.keywords.jigouname = vname
    },
    clickpay(row){
      this.$confirm('您确定要线上支付吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var url = "https://apirsl.eyesreal.com:8686/ApiJ01/OptometristPrescriptions/pay?orderid=" + row.Orderid
        window.open(url)
      })
    },
    clickModify(row){
      this.activeName = 'five'
      this.$refs.SubVuefive.ModifyData(row,this.SubRule_Optometrist_ShowPrice)
    },
    clickToView (row) {
      this.activeName = 'three'
      this.$refs.SubVuethree.ViewData(row,this.SubRule_Optometrist_ShowPrice)
    },
    clickreturn () {
      this.activeName = 'first'
    },
    clickdel (row) {
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apiDelOptometristPrescriptions(row.Orderid)
      })
    },
    clickNoOnlinePay (row,paymode) {
      this.$confirm('是否'+paymode+'?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apiNoOnlinePayOptometristPrescriptions(row.Orderid,paymode)
      })
    },
    clickSend(row){
      this.activeName = 'four'
      this.sendForm.orderid = row.Orderid
      this.sendForm.trackingname = ''
      this.sendForm.trackingnumber = ''
    },
    clickSendSave(){
      this.apiSendOptometristPrescriptions()
    },
    clickConfirmGoods(row){
      this.$confirm('是否确认收货?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apiConfirmGoodsOptometristPrescriptions(row.Orderid)
      })
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apiGetOptometristPrescriptionsNum()
      this.apiGetOptometristPrescriptionsList()
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiGetOptometristPrescriptionsList()
    },
    clickexcel () {
      this.apiExcelOptometristPrescriptionsList()
    },
    apiGetOptometristPrescriptionsNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        orderid: that.keywords.orderid,
        jigouid: that.keywords.jigouid,
        username: that.keywords.username,
        sex: that.keywords.sex,
        salechannel: that.keywords.salechannel,
        consignee: that.keywords.consignee,
        phone: that.keywords.phone,
        consigneeaddress: that.keywords.consigneeaddress,
        orderstatus: that.keywords.orderstatus,
        isyufukuan: that.keywords.isyufukuan
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetOptometristPrescriptionsNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetOptometristPrescriptionsList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        orderid: that.keywords.orderid,
        jigouid: that.keywords.jigouid,
        username: that.keywords.username,
        sex: that.keywords.sex,
        salechannel: that.keywords.salechannel,
        consignee: that.keywords.consignee,
        phone: that.keywords.phone,
        consigneeaddress: that.keywords.consigneeaddress,
        orderstatus: that.keywords.orderstatus,
        isyufukuan: that.keywords.isyufukuan
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetOptometristPrescriptionsList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiDelOptometristPrescriptions: function (orderid) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        orderid: orderid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_DelOptometristPrescriptions, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetOptometristPrescriptionsNum()
            that.apiGetOptometristPrescriptionsList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiNoOnlinePayOptometristPrescriptions: function (orderid,paymode) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        orderid: orderid,
        paymode: paymode
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_NoOnlinePayOptometristPrescriptions, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetOptometristPrescriptionsNum()
            that.apiGetOptometristPrescriptionsList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiExcelOptometristPrescriptions: function (row,exceltype) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        orderid: row.Orderid,
        exceltype:exceltype
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_ExcelOptometristPrescriptions, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.$confirm('是否跳转到文件管理，查看导出情况?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              showCancelButton: true,
              type: 'warning'
            }).then(() => {
              that.$router.push({ path: '/FileManagementExcel' })
            })
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiExcelOptometristPrescriptionsList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        orderid: that.keywords.orderid,
        jigouid: that.keywords.jigouid,
        username: that.keywords.username,
        sex: that.keywords.sex,
        salechannel: that.keywords.salechannel,
        consignee: that.keywords.consignee,
        phone: that.keywords.phone,
        consigneeaddress: that.keywords.consigneeaddress,
        orderstatus: that.keywords.orderstatus
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_ExcelOptometristPrescriptionsList, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.$confirm('是否跳转到文件管理，查看导出情况?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              showCancelButton: true,
              type: 'warning'
            }).then(() => {
              that.$router.push({ path: '/FileManagementExcel' })
            })
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiSendOptometristPrescriptions: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      data = { ...data, ...that.sendForm }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_SendOptometristPrescriptions, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetOptometristPrescriptionsNum()
            that.apiGetOptometristPrescriptionsList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiConfirmGoodsOptometristPrescriptions: function (orderid) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        orderid: orderid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_ConfirmGoodsOptometristPrescriptions, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetOptometristPrescriptionsNum()
            that.apiGetOptometristPrescriptionsList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.cell span{
    margin-left: 10px;
}
.select2{
    width: 100%;
}

/deep/ .el-dialog__body {
    padding: 20px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}
</style>
